import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";
import { getLinkTargetField } from "@/partner/features/links";

/** Тип ссылки пункта меню (значения из GraphQL-схемы). */
type MenuItemLinkType = "INTERNAL" | "EXTERNAL";

const LINK_TYPE_LABEL_KEYS: Record<MenuItemLinkType, string> = {
  INTERNAL: "platformMenu.linkType.internal",
  EXTERNAL: "platformMenu.linkType.external",
};

/**
 * Schema for platform menu item form
 * Uses block type to group fields into collapsible sections
 */

export const makePlatformMenuItemFormSchema = (
  t: TFunction,
  liveEnabled = true
): Schema => ({
  label: {
    type: "text",
    label: t("platformMenu.form.labelLabel"),
    required: true,
    xs: 12,
    fullWidth: true,
  },
  linkType: {
    type: "radioGroup",
    label: t("platformMenu.form.linkTypeLabel"),
    required: true,
    options: Object.entries(LINK_TYPE_LABEL_KEYS).map(([value, key]) => ({
      value,
      label: t(key),
    })),
    row: true,
    xs: 12,
    fullWidth: true,
  },
  href: {
    type: "text",
    label: t("platformMenu.form.hrefLabel"),
    required: true,
    xs: 12,
    fullWidth: true,
    visibleCheck: ({ allValues }) => allValues?.linkType === "EXTERNAL",
    helperText: t("platformMenu.form.hrefHelper"),
  },
  _object: {
    type: "selectObject",
    xs: 12,
    fullWidth: true,
    visibleCheck: ({ allValues }) => allValues?.linkType === "INTERNAL",
    ...getLinkTargetField(t, { liveEnabled }),
  },
  // _visibility: {
  //   type: "block",
  //   label: "Доступность",
  //   xs: 12,
  //   subschema: visibilityFormSchema,
  // },
});
